import { utilApiClientV1 } from '../../utils/RequestClient';

/**
 * @param {import('@action-types/internal-document').InternalDocumentParams} params
 * @returns {Promise<import('@action-types/internal-document').InternalDocumentResponse>}
 * @throws {import('@action-types/RequestError').RequestError<import('@action-types/internal-document').InternalDocumentApiErrorResponse>}
 */
const getInternalDocument = async ({ uri, appId, appType, token }) => {
  const { jsonResponse } = await utilApiClientV1.fetch({
    endpoint: '/internal/sign',
    requestOptions: {
      method: 'POST',
      body: JSON.stringify({ uri, appId, appType }),
      headers: {
        authorization: token,
      },
    },
  });

  return jsonResponse;
};

export default getInternalDocument;
